module.exports = __webpack_public_path__ + "img/login-hero.94ad3258.jpg";